/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { getColor } from '@airasia-phoenix/react-native/utils/utils';
import { StyleSheet } from 'react-native-unistyles';

const styles = StyleSheet.create((pd) => ({
  mainContainer: {
    gap: pd.ref.space.spacing40.px,
  },
  descContainer: {
    gap: pd.ref.space.spacing10.px,
  },
  rowContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: pd.ref.space.spacing10.px,
  },
  dividerRow: {
    paddingVertical: pd.ref.space.spacing20.px,
    flexDirection: 'row',
    alignItems: 'center',
  },
  divider: {
    flex: 1,
    height: 1,
    backgroundColor: getColor(pd.sys.colour.outline_low),
  },
  dividerTextContainer: {
    paddingHorizontal: pd.ref.space.spacing40.px,
  },
}));

export default styles;
